import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { LightChannelGroupLock } from '@ledium/types';
import { Description, GroupSelect, LediumForm, ShowIntensityValue, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { Container } from '@mui/material';

import DmxChannel from './Components/DmxChannel';
import LightChannelChart from './Components/LightChannelChart';
import LightChannelCsvUploadButton from './Components/LightChannelCsvUploadButton';
import ResolutionSelector from './Components/ResolutionSelector';

interface LightChannelsViewProps {
    onClose: () => void;
    onSave: () => void;
}

const LightChannelsView = ({ onClose, onSave }: LightChannelsViewProps) => {
    const {
        pageState: { formData }
    } = usePageStore();
    const groupLock = formData.groupLock as LightChannelGroupLock | null;

    return (
        <Container fixed>
            <LediumForm onSubmit={() => onSave()} onCancel={onClose} header={<TitleAndDescription />}>
                <UniqueName />
                <Description />
                <GroupSelect
                    label={i18n('group_of_the_lighting_device')}
                    disabled={!!groupLock}
                    disabledMessage={groupLock ? i18n(groupLock.reason, <b>{groupLock.spectrumMixName}</b>) : ''}
                />
                <ResolutionSelector />
                <ShowIntensityValue />
                <DmxChannel />
                <LightChannelCsvUploadButton />
                <LightChannelChart />
            </LediumForm>
        </Container>
    );
};

export default React.memo(LightChannelsView);
